import { c as _c } from "react/compiler-runtime";
import { Image } from '@petsmart-ui/sparky';
import Link from 'next/link';
import './brand-card.scss';
export type BrandCardModel = {
  href: string;
  imageUrl: string;
  label: string;
  openInNewTab?: boolean;
};
type BrandCardProps = {
  card: BrandCardModel;
  onClick?: () => void;
};
export function BrandCard(t0) {
  const $ = _c(11);
  const {
    card,
    onClick
  } = t0;
  const t1 = card.openInNewTab ? "noopener noreferrer" : undefined;
  const t2 = card.openInNewTab ? "_blank" : undefined;
  let t3;
  if ($[0] !== card.imageUrl) {
    t3 = <Image src={card.imageUrl} alt="" className="brand-card__image" loading="lazy" />;
    $[0] = card.imageUrl;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== card.label) {
    t4 = <span className="sparky-u-is-vishidden">{card.label}</span>;
    $[2] = card.label;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== card.href || $[5] !== onClick || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <Link href={card.href} className="brand-card" rel={t1} target={t2} onClick={onClick}>{t3}{t4}</Link>;
    $[4] = card.href;
    $[5] = onClick;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}